import { ConnectWalletModal } from '@/components/shared/ConnectWalletModal';
import { useAuthenticationModal } from '@/hooks/useAuthenticationModal';

export const AuthenticationModal = () => {
  const [isOpen, setOpen] = useAuthenticationModal(state => [state.isOpen, state.setOpen]);
  return <ConnectWalletModal isOpen={isOpen} onClose={() => setOpen(false)} />;
};
